if (!customElements.get('believ3rs-popup')) {
  customElements.define('believ3rs-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.key = 'b3-popup:' + this.dataset.section + ':' + this.dataset.campaign;
      this.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog || this.dataset.overlayClose !== 'true') return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('b3-popup-open');
        this.previousFocus?.focus();
      }, options);
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.section) this.show(true);
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.detail.sectionId === this.dataset.section) this.dialog.close();
        }, options);
        if (this.dataset.preview === 'true') this.timer = setTimeout(() => this.show(true), 300);
        return;
      }
      if (this.dataset.enabled !== 'true') return;
      if (this.querySelector('[data-popup-result]')) { this.show(true); return; }
      if (this.dataset.homeOnly === 'true' && this.dataset.home !== 'true') return;
      if (!this.allowedDevice() || this.seen()) return;
      if (this.dataset.trigger === 'scroll') {
        const onScroll = () => {
          const total = document.documentElement.scrollHeight - innerHeight;
          if (total > 0 && scrollY / total * 100 >= Number(this.dataset.scroll)) this.show();
        };
        window.addEventListener('scroll', onScroll, { ...options, passive: true });
        onScroll();
      } else if (this.dataset.trigger === 'exit') {
        document.addEventListener('mouseout', event => {
          if (!event.relatedTarget && event.clientY <= 0 && matchMedia('(hover: hover) and (pointer: fine)').matches) this.show();
        }, options);
      } else this.timer = setTimeout(() => this.show(), Number(this.dataset.delay) * 1000);
    }
    allowedDevice() {
      const mobile = matchMedia('(max-width: 749px)').matches;
      return this.dataset.devices === 'all' || (mobile ? this.dataset.devices === 'mobile' : this.dataset.devices === 'desktop');
    }
    seen() {
      try {
        if (this.dataset.frequency === 'session') return sessionStorage.getItem(this.key) === '1';
        if (this.dataset.frequency === 'days') return Date.now() - Number(localStorage.getItem(this.key) || 0) < Number(this.dataset.days) * 86400000;
      } catch (_) { /* Popup remains usable with blocked storage. */ }
      return false;
    }
    show(force = false) {
      if (!this.isConnected || this.dialog.open || (!force && (this.displayed || !this.allowedDevice()))) return;
      // Wait until the cart, navigation or another modal has closed.
      if (document.querySelector('cart-drawer.active, .b3-nyh-menu.is-open, dialog[open], details[open].menu-opening')) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.show(force), 1000);
        return;
      }
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      this.displayed = true;
      document.documentElement.classList.add('b3-popup-open');
      if (!window.Shopify?.designMode) {
        try {
          if (this.dataset.frequency === 'session') sessionStorage.setItem(this.key, '1');
          if (this.dataset.frequency === 'days') localStorage.setItem(this.key, String(Date.now()));
        } catch (_) { /* Storage may be unavailable in private browsers. */ }
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.classList.remove('b3-popup-open'); }
    }
  });
}
